export const env = {
	ENV: import.meta.env.REACT_APP_ENV,
	NODE_ENV: import.meta.env.MODE,
	APP: {
		BASE_PATH: import.meta.env.REACT_APP_BASE_PATH,
		VERSION: import.meta.env.REACT_APP_VERSION,
		PROJECT: import.meta.env.REACT_APP_PROJECT,
		NAME: import.meta.env.REACT_APP_NAME,
		TITLE: import.meta.env.REACT_APP_TITLE,
		DESCRIPTION: import.meta.env.REACT_APP_DESCRIPTION,
		SESSION_EXPIRATION_TIME: import.meta.env
			.REACT_REACT_APP_SESSION_EXPIRATION_TIME,
		LOGIN: import.meta.env.REACT_APP_LOGIN,
		API: import.meta.env.REACT_APP_API_ACHS,
	},
};
